import { SET_OCCUPANCY_DATA } from './mutations';

const setOccupancyData = ({ commit }, payload) => commit(SET_OCCUPANCY_DATA, payload);

export default { setOccupancyData };
